export const dashCase = (slug) => {
  return slug
    .toLowerCase() // To Lowercase
    .replace(/\s/g, "-") // Replace all spaces with a dash
    .replace(/[^a-z0-9]/g, "-") // Replace all non-alphabetic or numeric characters
    .replace(/[-]+/g, "-") // Replace all multiple dashes with one dash
    .replace(/-$/g, "") // If url ends with dash -> remove that dash
    .replace(/^-/g, ""); // If url begins with dash -> remove that dash
};
